module.exports = __webpack_public_path__ + "static/media/header.7ae4fe32.png";